export const IDENTITY_OPTIONS = [
  {
    value: 'merchant',
    label: 'Trusted Merchant',
  },
  {
    value: 'seBankID',
    label: 'SE BankId',
  },
  {
    value: 'noBankID',
    label: 'NO BankId',
  },
  {
    value: 'fiTupas',
    label: 'FI Tupas',
  },
  {
    value: 'onfido',
    label: 'Onfido',
  },
  {
    value: 'nlIDIN',
    label: 'NL Idin',
  },
];
